import { useEffect, useState } from "react";
import { getSoldeYear } from "../services/CongeService";


export function useSoldeYear(collaborateurId, year) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!collaborateurId || !year) {
            setData(null);
            setError(null);
            setLoading(false);
            return;
        }

        let cancelled = false;
        setLoading(true);
        setError(null);

        getSoldeYear(collaborateurId, year)
            .then((res) => {
                if (!cancelled) setData(res.data);
            })
            .catch((e) => {
                if (!cancelled) {
                    setError(e);
                    setData(null);
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false);
            });

        return () => {
            cancelled = true;
        };
    }, [collaborateurId, year]);

    return { data, loading, error };
}
